import Icon from "./icon";
import Link from "next/link";

import clsx from "clsx";

interface Props {
  name: string;
  slug: string;
  lessons: { watchedCount: number; totalCount: number };
  questions: { answeredCount: number; totalCount: number };
  group: { slug: string };
  step: number;
  loading?: boolean;
}

export default function Subject(props: Props): JSX.Element {
  const { name, slug, lessons, questions, group } = props;
  const { step } = props;
  const { loading } = props;

  const isCompleted =
    (questions.answeredCount > 0 &&
      questions.answeredCount == questions.totalCount) ||
    (questions.totalCount === 0 && lessons.watchedCount === lessons.totalCount);
  const backgroundColors = {
    "ciencias-exatas":
      "bg-gradient-to-bl bg-gradient-from-tr from-subjects-exact to-subjects-exact-dark",
    "ciencias-humanas":
      "bg-gradient-to-bl bg-gradient-from-tr from-subjects-human to-subjects-human-dark",
    linguagens:
      "bg-gradient-to-bl bg-gradient-from-tr from-subjects-languages to-subjects-languages-dark"
  };
  const textColors = {
    "ciencias-exatas": "text-subjects-exact-dark",
    "ciencias-humanas": "text-subjects-human-dark",
    linguagens: "text-subjects-languages-dark"
  };

  return (
    <Link href={`/plano/${slug}?etapa=${step}`}>
      <a
        className={clsx(
          "topic fade-loading relative block p-5 w-full h-full no-underline rounded-lg shadow overflow-hidden",
          { loading, "completed opacity-80": isCompleted },
          backgroundColors[group.slug]
        )}
      >
        <span className="block mb-4 text-white text-lg font-bold">{name}</span>

        <div className={clsx("absolute right-0 top-0", textColors[group.slug])}>
          <Icon slug={slug} />
        </div>

        <div className="flex flex-col">
          <Info
            label="aulas"
            completedCount={lessons.watchedCount}
            totalCount={lessons.totalCount}
          />
          <Info
            label="exercícios"
            completedCount={questions.answeredCount}
            totalCount={questions.totalCount}
          />
        </div>
      </a>
    </Link>
  );
}

type InfoProps = {
  label: string;
  completedCount: number;
  totalCount: number;
};

function Info(props: InfoProps) {
  const { label, completedCount, totalCount } = props;

  return (
    <span className="text-white text-opacity-80 font-semibold">
      {completedCount} / {totalCount} {label}
    </span>
  );
}
